module.exports = __webpack_public_path__ + "img/room-03.9466f208.jpg";